import {BaseDomainModel} from "../../../../../../infrastructure/models/base-domain-model";
import {GameStatsActualPlayTimeProgressApiModel} from "./game-stats.actual-play-time.progress.api-model";
export class GameStatsActualPlayTimeProgressDomainModel extends BaseDomainModel {
  apiModel: GameStatsActualPlayTimeProgressApiModel

  constructor(model: GameStatsActualPlayTimeProgressApiModel) {
    super(model)

    this.name = model.name;
    this.progress = model.progress;
  }
}
